import { Link } from '@apollo/orbit';
import React from 'react';

import { DocsRouter } from 'src/lib/routers';

import { ClientFilterTitle } from '../clientFilterTitle/ClientFilterTitle';

interface Props {
  title?: string;
}

export const ClientFilterEmpty = ({ title }: Props) => (
  <div className="p-4">
    {title ? <ClientFilterTitle>{title}</ClientFilterTitle> : null}
    <div className="rounded bg-neutral px-3 py-2">
      <div className="font-semibold">No clients have been defined.</div>
      <div className="leading-normal">
        Defining clients will help you know exactly which fields are used by a
        specific client.{' '}
        <Link isExternal to={DocsRouter.path('ClientAwareness')}>
          Learn more about Identifying Clients
        </Link>{' '}
        by visiting our docs.
      </div>
    </div>
  </div>
);
